/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable dot-notation */
/* eslint-disable prefer-const */
import React from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ContentItem, ContentPathEntry } from '@antegma/accallio-cloud-hootsuite-application-api-javacript-sdk'
import { UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { addItem } from '@antegma/accallio-cloud-react-components/lib/app/redux/breadcrumb/actions'
import { useUploadToComposer } from '~/hooks/useUploadToComposer'
import SocialCard from '~/components/social-media/socialcard'

type TCardProps = {
  contentItem: ContentItem
  currentFolderPath?: ContentPathEntry[]
}

const MediaCardView: React.FunctionComponent<TCardProps> = ({ contentItem, currentFolderPath }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { uploadToComposer } = useUploadToComposer()

  const openComposer = (): void => {
    uploadToComposer(contentItem)
  }

  const openDetail = (): void => {
    // Store the folder path in sessionStorage
    if (currentFolderPath) {
      console.log('MediaCardView - Storing folder path in sessionStorage:', currentFolderPath)
      sessionStorage.setItem('contentDetailsBreadcrumbPath', JSON.stringify(currentFolderPath))
    }
    history.push(`/contentdetails/${contentItem.id}`)
  }

  const onLoad = (): void => {
    /* console.log('load'); */
  }

  return (
    <>
      {contentItem.id?.includes('folder-') || contentItem.id?.includes('album-') ? (
        <SocialCard actions={[]} key={contentItem.id} contentItem={contentItem} onLoad={onLoad} />
      ) : (
        <SocialCard
          key={contentItem.id}
          actions={[
            <Button type="link" onClick={openDetail}>
              View Details
            </Button>,
            <Button type="link" icon={<UploadOutlined />} onClick={openComposer}>
              Open in Composer
            </Button>,
          ]}
          contentItem={contentItem}
          onLoad={onLoad}
        />
      )}
    </>
  )
}

export default MediaCardView
